import React from 'react'
import styles from './Sidebar.module.scss'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'
import ToggleButton from '@material-ui/lab/ToggleButton'
import { makeStyles } from '@material-ui/core/styles'
import { Avatar } from '@material-ui/core'
import getInitials from '../../helpers/getNameInitials'

const moment = require('moment')
moment.locale('en')

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  commentsButton: {
    padding: '0',
    border: 'none',
    height: 'fit-content',
    margin: '10px',
  },
}))

const CommentsItems = (props) => {
  const classes = useStyles()

  return (
    <div className={styles.UserCommentWrapper} key={props.item.id}>
      <div className={styles.UserCommentHeader}>
        <div className={styles.UserName}>{props.item.user.name}</div>
        <div className={styles.Date}>
          {moment(props.item.creation_date).format('MMM D, YYYY')}
        </div>
      </div>
      <div className={styles.UserCommentMain}>
        <div className={styles.UserCommentLogo}>
          {props.item.user && props.item.user.file_url ? (
            <img
              className={styles.UserCommentLogoImg}
              src={props.item.user.file_url}
            />
          ) : (
            <Avatar
              style={{ width: '35px', height: '35px', margin: '3px 0 0 2px' }}
            >
              {getInitials(props.item.user.name)}
            </Avatar>
          )}
        </div>
        <div className={styles.UserCommentText}>{props.item.value}</div>
      </div>
      <div className={styles.LikeBlockR}>
        <ToggleButtonGroup aria-label="text alignment" className={classes.root}>
          <ToggleButton
            className={classes.commentsButton}
            value="1"
            onClick={() => props.likeHandler('1', 'MarkComment', props.item)}
          >
            <ThumbUpIcon style={{ color: '#3BBDE3' }} />
          </ToggleButton>
          <ToggleButton
            className={classes.commentsButton}
            value="-1"
            onClick={() => props.likeHandler('-1', 'MarkComment', props.item)}
          >
            <ThumbDownIcon style={{ color: '#FC2A3A' }} />
          </ToggleButton>
        </ToggleButtonGroup>
        <div className={styles.TotalCount}>
          {props.item.likes_count ? props.item.likes_count : '0'}
        </div>
      </div>
    </div>
  )
}

export default CommentsItems
